import { render, staticRenderFns } from "./ShowService.vue?vue&type=template&id=5e1c1e8f&scoped=true&"
import script from "./ShowService.vue?vue&type=script&lang=js&"
export * from "./ShowService.vue?vue&type=script&lang=js&"
import style0 from "./ShowService.vue?vue&type=style&index=0&id=5e1c1e8f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1c1e8f",
  null
  
)

export default component.exports